import m, {Vnode, VnodeDOM} from "mithril";
import moment, {Moment} from "moment";
import ICustomForm from "../../ICustomForm";
import DateTime from "../DateTime";
import DatePicker from "../DatePicker";
import ICustomFormSettings from "../../ICustomFormSettings";
import h from "../../../ui/design";
import DateFormats, {NationalDateFormat} from "../DateFormats";

export default class DateTimeTime extends DateTime implements ICustomForm
{
    private readonly datePicker: DatePicker;
    public readonly dateFormat: NationalDateFormat;

    static readonly SE2_FORMAT = 'HH:mm';

    constructor(settings: ICustomFormSettings) {
        super(settings);

        const locale = this.settings.form.questionary.guessLocale();
        moment.locale(locale);

        this.dateFormat = DateFormats.time(locale);
        this.datePicker = new DatePicker(
            this.date,
            (date: Moment) => {this.date = date;},
            this.dateInputCell,
            this.dateFormat
        );

    }

    private set date(date: Moment|null) {
        this.setVariable(this.variableName, date === null ? undefined : date.format(DateTimeTime.SE2_FORMAT));
    }

    private get date(): Moment|null {
        const formatted: string|undefined = this.getVariable(this.variableName);
        if (formatted) {
            return moment(formatted, DateTimeTime.SE2_FORMAT)
        }
        return null;
    }

    public view() {
        const form = this.settings.form;
        const questionary = form.questionary;

        return this.viewLayout([
            m("form", {}, [
                m(this.datePicker),
                m("p.hint", {}, questionary.renderText(questionary.messages.get('tapOrArrowsToSetTime', {format: 'hh:mm'}))),
            ]),
            this.errorMessage ? m("div.error-alert", this.errorMessage) : null,
            m('.', {}, this.checkboxes.map(cell => m(cell))),
        ]);
    }

    oncreate(vnode: VnodeDOM) {
        super.oncreate(vnode);
        if (window.innerWidth >= h.BC.md) {
            setTimeout(() => {$(vnode.dom).find('input').first().focus();}, 50);
        }
    }
}
